'use client';
import { Button } from '@common/components';
import { useEffect, useState } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';
import { ROUTES } from '@/constants/routes';

const POLICY_BANNER_IMAGES = [
  '/static/home/character.png',
  '/static/home/gold-money.png',
];
const IMAGE_ROTATION_INTERVAL = 1000;

export const PolicyDataBanner = () => {
  const [currentImage, setCurrentImage] = useState<number>(0);
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    setStartAnimation(true);
    const intervalId = window.setInterval(() => {
      setCurrentImage((prev) => {
        if (prev === null) {
          return 0;
        }

        return (prev + 1) % POLICY_BANNER_IMAGES.length;
      });
    }, IMAGE_ROTATION_INTERVAL);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <section className="px-20 pt-8">
      <div className="flex flex-col items-center gap-20 rounded-[32px] bg-B-500 p-28 pb-12 shadow-sm">
        <p className="text-center font-700 text-Gray-white typo-h6">
          나를 위한 정부지원금,
          <br />
          얼마인지 확인해볼까요?
        </p>
        <div className="flex w-full flex-col items-center gap-8">
          <div
            className="relative flex size-130 items-center justify-center"
            style={{ opacity: startAnimation ? 1 : 0 }}
          >
            {POLICY_BANNER_IMAGES.map((image, index) => {
              const isActive = startAnimation && currentImage === index;

              return (
                <div
                  key={image}
                  className="absolute inset-0 flex size-130 items-center justify-center"
                  style={{
                    opacity: isActive ? 1 : 0,
                    transform: isActive ? 'scale(1)' : 'scale(0.8)',
                    transition: isActive
                      ? 'opacity 0.2s ease-out 0.1s, transform 0.2s ease-out 0.1s'
                      : 'opacity 0.2s ease-in, transform 0.2s ease-in',
                  }}
                >
                  <Image
                    src={`${WELLO_IMAGE_PREFIX_URL}${image}`}
                    alt="정책 데이터"
                    width={130 * 2}
                    height={130 * 2}
                    className="size-130"
                    {...(index === 0 && { loading: 'eager' })}
                  />
                </div>
              );
            })}
          </div>

          <div className="flex w-full flex-col gap-2">
            <Button
              asChild
              theme="secondary-fill"
              className="text-body3 w-full rounded-small bg-Gray-100 text-Gray-700 hover:bg-Gray-100"
            >
              <CustomLink href={ROUTES.RECOMMEND_POLICY_LIST.pathname}>
                10초만에 맞춤정책 맛보기
              </CustomLink>
            </Button>
            <Button asChild theme="sub-text" className="w-full text-Gray-white">
              <CustomLink
                href={ROUTES.LOGIN.withSearchParams({
                  searchParams: {
                    redirect: ROUTES.HOME.pathname,
                  },
                })}
              >
                로그인 하러가기
              </CustomLink>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
